import { CircleStop, Copy, Trash } from "lucide-react";
import TaskEmployees from "./TaskEmployees";
import SmartDatePicker from "./SmartDatePicker";

const BulkActionsBar = ({
  allSelectedTasks = [],
  selectedTaskObjects = [],
  statuses = [],
  showStatusDropdown,
  setShowStatusDropdown,
  handleBulkStatusUpdate,
  commonAssignees = [],
  handleBulkAssigneeUpdate,
  employees = [],
  showDatePicker,
  setShowDatePicker,
  bulkDueDate,
  setBulkDueDate,
  handleBulkDateUpdate,
  handleCopyTasks,
  handleDeleteTasks,
  statusRef,
  activeProjectId,
  formatStatusLabel,
  TaskPriority,
  commonPriority,
  handleBulkPriorityUpdate
}) => {

  const currentStatus =
    selectedTaskObjects.length > 0 &&
      selectedTaskObjects.every(
        (t) => t.status === selectedTaskObjects[0]?.status
      )
      ? selectedTaskObjects[0]?.status
      : "Multiple";

  return (
    <div
      className={`
    fixed bottom-4 left-1/2 -translate-x-1/2
    w-[95%] sm:w-[90%] lg:w-[85%] xl:max-w-6xl
    bg-[#202020] text-white text-[12px] sm:text-[14px] font-light
    border rounded-lg gap-4
    transition-all duration-300 ease-in-out
    py-3 sm:py-4 xl:py-[40px]
    px-3 sm:px-4 xl:px-[20px]
    z-[50]

    ${activeProjectId && allSelectedTasks.length > 0
          ? "translate-y-0 opacity-100"
          : "translate-y-[120%] opacity-0 pointer-events-none"
        }
  `}
    >
      <div className="flex items-center justify-between">
        <span className="text-[11px] sm:text-[15px] md:text-[16px]">
          {allSelectedTasks.length} Task{allSelectedTasks.length > 1 ? "s" : ""} selected
        </span>

        <div className="flex items-center gap:[0] sm:gap-[10px] ">
          <div className="relative flex items-center" ref={statusRef}>

            {/* Status Button */}
            <div
              className="
      flex items-center gap-2
     px-1 sm:px-3 py-[3px] sm:py-1.5
      rounded-md
      bg-gray-700 text-white
      text-sm font-medium
      shadow-sm
      cursor-pointer
    "
              onClick={() => setShowStatusDropdown((prev) => !prev)}
            >
              <CircleStop size={15} />
              <span className="text-[12px] sm:text-[15px] md:text-[16px]">
                {currentStatus === "Multiple"
                  ? "Multiple"
                  : formatStatusLabel(currentStatus)}
              </span>
            </div>


            {showStatusDropdown && (
              <div
                className="
        absolute bottom-full left-0 mb-2
        w-44 max-h-56
        bg-white
        border border-gray-200
        rounded-xl
        shadow-xl
        overflow-hidden   
        overflow-y-auto
        z-50
        animate-fadeIn
      "
              >

                {[...new Set(statuses)].map((status) => {
                  const isActive = selectedTaskObjects.every(
                    (task) => task.status === status
                  );

                  return (
                    <div
                      key={status}
                      onClick={() => handleBulkStatusUpdate(status)}
                      className={`
              px-4 py-2.5
              md:px-3  text-[11px] md:text-sm
              cursor-pointer
              flex items-center justify-between
              transition-all
              ${isActive
                          ? "bg-gray-800 text-white font-semibold"
                          : "text-gray-700 hover:bg-gray-100"
                        }
            `}
                    >
                      <span>{formatStatusLabel(status)}</span>

                      {isActive && (
                        <span className="text-xs opacity-80">✓</span>
                      )}
                    </div>
                  );
                })}

              </div>
            )}
          </div>


          {/* Priority Dropdown */}
          <div className="px-2 py-1 text-black cursor-pointer  flex items-center gap-[5px]  hover:bg-opacity-20 rounded transition-colors">
            <TaskPriority
              value={commonPriority}
              onChange={(priority) => handleBulkPriorityUpdate(priority)}
              placement="top"
              align="right"
            />
          </div>

          {/* Assignees Dropdown */}
          <div className="hidden xs:flex px-2 py-1 cursor-pointer items-center gap-[5px]  hover:bg-opacity-20 rounded transition-colors">
            <TaskEmployees
              selected={commonAssignees}
              onChange={handleBulkAssigneeUpdate}
              employees={employees}
              className="task-dropdown"
              placement="top"
            />
          </div>

          {/* Due Date Picker */}
          <div className="hidden xs:flex  px-2 py-1 cursor-pointer  items-center gap-[5px] relative text-white  hover:bg-opacity-20 rounded transition-colors">
            <div className="bulkdate-calender flex">
              <SmartDatePicker
                placement="top"
                open={showDatePicker === "bulk"}
                setOpen={(v) => setShowDatePicker(v ? "bulk" : null)}
                selected={bulkDueDate}
                setSelected={(d) => {
                  setBulkDueDate(d);
                  handleBulkDateUpdate(d);
                }}
              />
            </div>
          </div>

          <div
            className="px-2 py-1 cursor-pointer  hover:bg-opacity-20 rounded transition-colors"
            onClick={handleCopyTasks}
          >
            <Copy size={16} />
          </div>

          <div
            className="px-2 py-1 text-red-600 cursor-pointer  hover:bg-opacity-20 rounded transition-colors"
            onClick={handleDeleteTasks}
          >
            <Trash size={16} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;
